module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/069-british-indian-ocean-territory-451c58d482c3c5d9d9f47aa229f27b15.svg";